import { CLIENT } from "../actions";

const defaultState = {
  searchResults: [],
  selectedClient: null,
  searchStatus: "IDLE",
  error: false
};

const loading = state => ({ ...state, searchStatus: "LOADING", error: false });
const fetchSuccess = (state, { payload }) => {
  return {
    ...state,
    searchResults: payload,
    searchStatus: "FINISHED",
    error: false
  };
};
const setClient = (state, { payload }) => {
  return {
    ...state,
    selectedClient: payload
  };
};
const clear = () => ({ ...defaultState });
const fetchError = state => ({ ...state, searchStatus: "FINISHED", error: true });
const ACTION_HANDLERS = {
  [CLIENT.LOADING]: loading,
  [CLIENT.FETCH_SUCCESS]: fetchSuccess,
  [CLIENT.FETCH_ERROR]: fetchError,
  [CLIENT.SET_CLIENT]: setClient,
  [CLIENT.CLEAR]: clear
};

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  const newState = handler ? handler(state, action) : state;
  return newState;
};